/**
 * Telas estáticas de apoio aos testes de interface (`/__e2e/*`).
 *
 * Elas não têm dados reais, mas também não devem ficar acessíveis no app
 * publicado. Ficam disponíveis apenas em desenvolvimento local e no ambiente
 * de preview (onde a suíte de regressão visual roda).
 */
export function areE2EPreviewsEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("id-preview--") ||
    hostname.endsWith(".lovableproject.com")
  );
}
